module.exports = __webpack_public_path__ + "static/media/avatar4.8ff63a48.jpg";